export default "__VITE_ASSET__cb63037c__"